import React from 'react';

import {
  useAccountNumbersForm,
  useAccountNumbersState,
  useDefaultAccountListener,
} from '@atlas/core';
import { Button, Loader } from '@atlas/ui';

import AccountNumberForm from './AccountNumberForm';

const AccountNumbersForm = () => {
  const { isAddButtonVisible, isLoading, isValid, onSubmit } = useAccountNumbersForm();
  const { appendField, bankAccountsLoading, state } = useAccountNumbersState();

  useDefaultAccountListener();

  if (bankAccountsLoading) {
    return <Loader />;
  }

  return (
    <form className="account-numbers-form">
      {state.map(({ useByDefault }, index) => (
        <AccountNumberForm fieldIndex={index} key={index} useByDefault={useByDefault} />
      ))}
      <div className="account-numbers-form__footer">
        {isAddButtonVisible && (
          <Button
            className="add-account-button"
            icon="add"
            label="account_numbers_add_one_more_account"
            onClick={appendField}
            size="big"
            type="secondary"
          />
        )}
        <Button
          disabled={!isValid || isLoading}
          label="account_numbers_submit"
          loading={isLoading}
          onClick={onSubmit}
          size="big"
        />
      </div>
    </form>
  );
};

export default AccountNumbersForm;
